import { FC, memo } from 'react'

import { Link } from '~/components/Link'
import { TopicOverview } from '~/types/theory'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ChevronRightIcon from '~/components/Icons/svgs/ChevronRightIcon'

interface SubTopicItemProps {
  activeClassName: string
  onMouseEnter: (subTopic: TopicOverview) => void
  topic: TopicOverview
}

const SubTopicItemComponent: FC<SubTopicItemProps> = ({ activeClassName, onMouseEnter, topic }) => {
  return (
    <Link
      className={`p-3 space-x-4 flex items-center justify-between rounded text-gray-link ${activeClassName}`}
      key={topic.path}
      onMouseEnter={() => onMouseEnter(topic)}
      to={topic.path}
    >
      <span className="text-xs">{topic.h1}</span>
      <span className="block shrink-0 text-2.5">
        {'children' in topic && <SVGIcon icon={ChevronRightIcon} pathClassName="text-black" size={8} />}
      </span>
    </Link>
  )
}
export const SubTopicItem = memo(SubTopicItemComponent)
